"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MaterialMultiPointData_alphaMap_0, _MaterialMultiPointData_alphaMap_1, _MaterialMultiPointData_alphaMap_2, _MaterialMultiPointData_alphaMap_3, _MaterialMultiPointData_alphaMap_4, _MaterialMultiPointData_alphaMap_5, _MaterialMultiPointData_alphaMap_6, _MaterialMultiPointData_alphaMap_7, _MaterialMultiPointData_color_0, _MaterialMultiPointData_color_1, _MaterialMultiPointData_color_2, _MaterialMultiPointData_color_3, _MaterialMultiPointData_color_4, _MaterialMultiPointData_color_5, _MaterialMultiPointData_color_6, _MaterialMultiPointData_color_7, _MaterialMultiPointData_map_0, _MaterialMultiPointData_map_1, _MaterialMultiPointData_map_2, _MaterialMultiPointData_map_3, _MaterialMultiPointData_map_4, _MaterialMultiPointData_map_5, _MaterialMultiPointData_map_6, _MaterialMultiPointData_map_7, _MaterialMultiPointData_materialIndexDataMap, _MaterialMultiPointData_materialIndexDataMapSize, _MaterialMultiPointData_sizeAttenuation_0, _MaterialMultiPointData_sizeAttenuation_1, _MaterialMultiPointData_sizeAttenuation_2, _MaterialMultiPointData_sizeAttenuation_3, _MaterialMultiPointData_sizeAttenuation_4, _MaterialMultiPointData_sizeAttenuation_5, _MaterialMultiPointData_sizeAttenuation_6, _MaterialMultiPointData_sizeAttenuation_7, _MaterialMultiPointData_size_0, _MaterialMultiPointData_size_1, _MaterialMultiPointData_size_2, _MaterialMultiPointData_size_3, _MaterialMultiPointData_size_4, _MaterialMultiPointData_size_5, _MaterialMultiPointData_size_6, _MaterialMultiPointData_size_7;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialMultiPointData = void 0;
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const AbstractMaterialData_1 = require("./AbstractMaterialData");
class MaterialMultiPointData extends AbstractMaterialData_1.AbstractMaterialData {
    // #endregion Properties (20)
    // #region Constructors (1)
    /**
     * Creates a material data object.
     *
     * @param _attributes the attributes of the material
     * @param id the id
     */
    constructor(properties, id, version) {
        super(properties, id, version);
        // #region Properties (20)
        _MaterialMultiPointData_alphaMap_0.set(this, undefined);
        _MaterialMultiPointData_alphaMap_1.set(this, undefined);
        _MaterialMultiPointData_alphaMap_2.set(this, undefined);
        _MaterialMultiPointData_alphaMap_3.set(this, undefined);
        _MaterialMultiPointData_alphaMap_4.set(this, undefined);
        _MaterialMultiPointData_alphaMap_5.set(this, undefined);
        _MaterialMultiPointData_alphaMap_6.set(this, undefined);
        _MaterialMultiPointData_alphaMap_7.set(this, undefined);
        _MaterialMultiPointData_color_0.set(this, "#ffffff");
        _MaterialMultiPointData_color_1.set(this, "#ffffff");
        _MaterialMultiPointData_color_2.set(this, "#ffffff");
        _MaterialMultiPointData_color_3.set(this, "#ffffff");
        _MaterialMultiPointData_color_4.set(this, "#ffffff");
        _MaterialMultiPointData_color_5.set(this, "#ffffff");
        _MaterialMultiPointData_color_6.set(this, "#ffffff");
        _MaterialMultiPointData_color_7.set(this, "#ffffff");
        _MaterialMultiPointData_map_0.set(this, undefined);
        _MaterialMultiPointData_map_1.set(this, undefined);
        _MaterialMultiPointData_map_2.set(this, undefined);
        _MaterialMultiPointData_map_3.set(this, undefined);
        _MaterialMultiPointData_map_4.set(this, undefined);
        _MaterialMultiPointData_map_5.set(this, undefined);
        _MaterialMultiPointData_map_6.set(this, undefined);
        _MaterialMultiPointData_map_7.set(this, undefined);
        _MaterialMultiPointData_materialIndexDataMap.set(this, undefined);
        _MaterialMultiPointData_materialIndexDataMapSize.set(this, undefined);
        _MaterialMultiPointData_sizeAttenuation_0.set(this, undefined);
        _MaterialMultiPointData_sizeAttenuation_1.set(this, undefined);
        _MaterialMultiPointData_sizeAttenuation_2.set(this, undefined);
        _MaterialMultiPointData_sizeAttenuation_3.set(this, undefined);
        _MaterialMultiPointData_sizeAttenuation_4.set(this, undefined);
        _MaterialMultiPointData_sizeAttenuation_5.set(this, undefined);
        _MaterialMultiPointData_sizeAttenuation_6.set(this, undefined);
        _MaterialMultiPointData_sizeAttenuation_7.set(this, undefined);
        _MaterialMultiPointData_size_0.set(this, undefined);
        _MaterialMultiPointData_size_1.set(this, undefined);
        _MaterialMultiPointData_size_2.set(this, undefined);
        _MaterialMultiPointData_size_3.set(this, undefined);
        _MaterialMultiPointData_size_4.set(this, undefined);
        _MaterialMultiPointData_size_5.set(this, undefined);
        _MaterialMultiPointData_size_6.set(this, undefined);
        _MaterialMultiPointData_size_7.set(this, undefined);
        if (!properties)
            return;
        if (properties.materialIndexDataMap !== undefined)
            this.materialIndexDataMap = properties.materialIndexDataMap;
        if (properties.materialIndexDataMapSize !== undefined)
            this.materialIndexDataMapSize = properties.materialIndexDataMapSize;
        if (properties.alphaMap_0 !== undefined)
            this.alphaMap_0 = properties.alphaMap_0;
        else if (properties.alphaMap !== undefined)
            this.alphaMap_0 = properties.alphaMap;
        if (properties.color_0 !== undefined)
            this.color_0 = properties.color_0;
        else if (properties.color !== undefined)
            this.color_0 = properties.color;
        if (properties.map_0 !== undefined)
            this.map_0 = properties.map_0;
        else if (properties.map !== undefined)
            this.map_0 = properties.map;
        if (properties.size_0 !== undefined)
            this.size_0 = properties.size_0;
        if (properties.sizeAttenuation_0 !== undefined)
            this.sizeAttenuation_0 = properties.sizeAttenuation_0;
        if (properties.alphaMap_1 !== undefined)
            this.alphaMap_1 = properties.alphaMap_1;
        else if (properties.alphaMap !== undefined)
            this.alphaMap_1 = properties.alphaMap;
        if (properties.color_1 !== undefined)
            this.color_1 = properties.color_1;
        else if (properties.color !== undefined)
            this.color_1 = properties.color;
        if (properties.map_1 !== undefined)
            this.map_1 = properties.map_1;
        else if (properties.map !== undefined)
            this.map_1 = properties.map;
        if (properties.size_1 !== undefined)
            this.size_1 = properties.size_1;
        if (properties.sizeAttenuation_1 !== undefined)
            this.sizeAttenuation_1 = properties.sizeAttenuation_1;
        if (properties.alphaMap_2 !== undefined)
            this.alphaMap_2 = properties.alphaMap_2;
        else if (properties.alphaMap !== undefined)
            this.alphaMap_2 = properties.alphaMap;
        if (properties.color_2 !== undefined)
            this.color_2 = properties.color_2;
        else if (properties.color !== undefined)
            this.color_2 = properties.color;
        if (properties.map_2 !== undefined)
            this.map_2 = properties.map_2;
        else if (properties.map !== undefined)
            this.map_2 = properties.map;
        if (properties.size_2 !== undefined)
            this.size_2 = properties.size_2;
        if (properties.sizeAttenuation_2 !== undefined)
            this.sizeAttenuation_2 = properties.sizeAttenuation_2;
        if (properties.alphaMap_3 !== undefined)
            this.alphaMap_3 = properties.alphaMap_3;
        else if (properties.alphaMap !== undefined)
            this.alphaMap_3 = properties.alphaMap;
        if (properties.color_3 !== undefined)
            this.color_3 = properties.color_3;
        else if (properties.color !== undefined)
            this.color_3 = properties.color;
        if (properties.map_3 !== undefined)
            this.map_3 = properties.map_3;
        else if (properties.map !== undefined)
            this.map_3 = properties.map;
        if (properties.size_3 !== undefined)
            this.size_3 = properties.size_3;
        if (properties.sizeAttenuation_3 !== undefined)
            this.sizeAttenuation_3 = properties.sizeAttenuation_3;
        if (properties.alphaMap_4 !== undefined)
            this.alphaMap_4 = properties.alphaMap_4;
        else if (properties.alphaMap !== undefined)
            this.alphaMap_4 = properties.alphaMap;
        if (properties.color_4 !== undefined)
            this.color_4 = properties.color_4;
        else if (properties.color !== undefined)
            this.color_4 = properties.color;
        if (properties.map_4 !== undefined)
            this.map_4 = properties.map_4;
        else if (properties.map !== undefined)
            this.map_4 = properties.map;
        if (properties.size_4 !== undefined)
            this.size_4 = properties.size_4;
        if (properties.sizeAttenuation_4 !== undefined)
            this.sizeAttenuation_4 = properties.sizeAttenuation_4;
        if (properties.alphaMap_5 !== undefined)
            this.alphaMap_5 = properties.alphaMap_5;
        else if (properties.alphaMap !== undefined)
            this.alphaMap_5 = properties.alphaMap;
        if (properties.color_5 !== undefined)
            this.color_5 = properties.color_5;
        else if (properties.color !== undefined)
            this.color_5 = properties.color;
        if (properties.map_5 !== undefined)
            this.map_5 = properties.map_5;
        else if (properties.map !== undefined)
            this.map_5 = properties.map;
        if (properties.size_5 !== undefined)
            this.size_5 = properties.size_5;
        if (properties.sizeAttenuation_5 !== undefined)
            this.sizeAttenuation_5 = properties.sizeAttenuation_5;
        if (properties.alphaMap_6 !== undefined)
            this.alphaMap_6 = properties.alphaMap_6;
        else if (properties.alphaMap !== undefined)
            this.alphaMap_6 = properties.alphaMap;
        if (properties.color_6 !== undefined)
            this.color_6 = properties.color_6;
        else if (properties.color !== undefined)
            this.color_6 = properties.color;
        if (properties.map_6 !== undefined)
            this.map_6 = properties.map_6;
        else if (properties.map !== undefined)
            this.map_6 = properties.map;
        if (properties.size_6 !== undefined)
            this.size_6 = properties.size_6;
        if (properties.sizeAttenuation_6 !== undefined)
            this.sizeAttenuation_6 = properties.sizeAttenuation_6;
        if (properties.alphaMap_7 !== undefined)
            this.alphaMap_7 = properties.alphaMap_7;
        else if (properties.alphaMap !== undefined)
            this.alphaMap_7 = properties.alphaMap;
        if (properties.color_7 !== undefined)
            this.color_7 = properties.color_7;
        else if (properties.color !== undefined)
            this.color_7 = properties.color;
        if (properties.map_7 !== undefined)
            this.map_7 = properties.map_7;
        else if (properties.map !== undefined)
            this.map_7 = properties.map;
        if (properties.size_7 !== undefined)
            this.size_7 = properties.size_7;
        if (properties.sizeAttenuation_7 !== undefined)
            this.sizeAttenuation_7 = properties.sizeAttenuation_7;
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (40)
    get alphaMap_0() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_alphaMap_0, "f");
    }
    set alphaMap_0(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_alphaMap_0, value, "f");
    }
    get alphaMap_1() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_alphaMap_1, "f");
    }
    set alphaMap_1(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_alphaMap_1, value, "f");
    }
    get alphaMap_2() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_alphaMap_2, "f");
    }
    set alphaMap_2(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_alphaMap_2, value, "f");
    }
    get color_0() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_color_0, "f");
    }
    set color_0(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_color_0, value, "f");
    }
    get color_1() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_color_1, "f");
    }
    set color_1(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_color_1, value, "f");
    }
    get color_2() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_color_2, "f");
    }
    set color_2(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_color_2, value, "f");
    }
    get map_0() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_map_0, "f");
    }
    set map_0(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_map_0, value, "f");
    }
    get map_1() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_map_1, "f");
    }
    set map_1(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_map_1, value, "f");
    }
    get map_2() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_map_2, "f");
    }
    set map_2(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_map_2, value, "f");
    }
    get materialIndexDataMap() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_materialIndexDataMap, "f");
    }
    set materialIndexDataMap(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_materialIndexDataMap, value, "f");
    }
    get materialIndexDataMapSize() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_materialIndexDataMapSize, "f");
    }
    set materialIndexDataMapSize(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_materialIndexDataMapSize, value, "f");
    }
    get sizeAttenuation_0() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_sizeAttenuation_0, "f");
    }
    set sizeAttenuation_0(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_sizeAttenuation_0, value, "f");
    }
    get sizeAttenuation_1() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_sizeAttenuation_1, "f");
    }
    set sizeAttenuation_1(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_sizeAttenuation_1, value, "f");
    }
    get sizeAttenuation_2() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_sizeAttenuation_2, "f");
    }
    set sizeAttenuation_2(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_sizeAttenuation_2, value, "f");
    }
    get size_0() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_size_0, "f");
    }
    set size_0(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_size_0, value, "f");
    }
    get size_1() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_size_1, "f");
    }
    set size_1(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_size_1, value, "f");
    }
    get size_2() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_size_2, "f");
    }
    set size_2(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_size_2, value, "f");
    }
    get alphaMap_3() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_alphaMap_3, "f");
    }
    set alphaMap_3(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_alphaMap_3, value, "f");
    }
    get color_3() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_color_3, "f");
    }
    set color_3(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_color_3, value, "f");
    }
    get map_3() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_map_3, "f");
    }
    set map_3(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_map_3, value, "f");
    }
    get size_3() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_size_3, "f");
    }
    set size_3(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_size_3, value, "f");
    }
    get sizeAttenuation_3() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_sizeAttenuation_3, "f");
    }
    set sizeAttenuation_3(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_sizeAttenuation_3, value, "f");
    }
    get alphaMap_4() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_alphaMap_4, "f");
    }
    set alphaMap_4(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_alphaMap_4, value, "f");
    }
    get color_4() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_color_4, "f");
    }
    set color_4(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_color_4, value, "f");
    }
    get map_4() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_map_4, "f");
    }
    set map_4(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_map_4, value, "f");
    }
    get size_4() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_size_4, "f");
    }
    set size_4(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_size_4, value, "f");
    }
    get sizeAttenuation_4() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_sizeAttenuation_4, "f");
    }
    set sizeAttenuation_4(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_sizeAttenuation_4, value, "f");
    }
    get alphaMap_5() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_alphaMap_5, "f");
    }
    set alphaMap_5(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_alphaMap_5, value, "f");
    }
    get color_5() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_color_5, "f");
    }
    set color_5(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_color_5, value, "f");
    }
    get map_5() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_map_5, "f");
    }
    set map_5(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_map_5, value, "f");
    }
    get size_5() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_size_5, "f");
    }
    set size_5(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_size_5, value, "f");
    }
    get sizeAttenuation_5() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_sizeAttenuation_5, "f");
    }
    set sizeAttenuation_5(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_sizeAttenuation_5, value, "f");
    }
    get alphaMap_6() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_alphaMap_6, "f");
    }
    set alphaMap_6(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_alphaMap_6, value, "f");
    }
    get color_6() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_color_6, "f");
    }
    set color_6(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_color_6, value, "f");
    }
    get map_6() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_map_6, "f");
    }
    set map_6(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_map_6, value, "f");
    }
    get size_6() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_size_6, "f");
    }
    set size_6(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_size_6, value, "f");
    }
    get sizeAttenuation_6() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_sizeAttenuation_6, "f");
    }
    set sizeAttenuation_6(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_sizeAttenuation_6, value, "f");
    }
    get alphaMap_7() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_alphaMap_7, "f");
    }
    set alphaMap_7(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_alphaMap_7, value, "f");
    }
    get color_7() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_color_7, "f");
    }
    set color_7(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_color_7, value, "f");
    }
    get map_7() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_map_7, "f");
    }
    set map_7(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_map_7, value, "f");
    }
    get size_7() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_size_7, "f");
    }
    set size_7(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_size_7, value, "f");
    }
    get sizeAttenuation_7() {
        return __classPrivateFieldGet(this, _MaterialMultiPointData_sizeAttenuation_7, "f");
    }
    set sizeAttenuation_7(value) {
        __classPrivateFieldSet(this, _MaterialMultiPointData_sizeAttenuation_7, value, "f");
    }
    // #endregion Public Getters And Setters (40)
    // #region Public Methods (3)
    clone() {
        return new MaterialMultiPointData({
            alphaMode: this.alphaMode,
            alphaCutoff: this.alphaCutoff,
            aoMap: this.aoMap,
            aoMapIntensity: this.aoMapIntensity,
            bumpMap: this.bumpMap,
            bumpScale: this.bumpScale,
            depthTest: this.depthTest,
            depthWrite: this.depthWrite,
            emissiveMap: this.emissiveMap,
            emissiveness: this.emissiveness,
            shading: this.shading,
            name: this.name,
            normalMap: this.normalMap,
            normalScale: this.normalScale,
            opacity: this.opacity,
            side: this.side,
            transparent: this.transparent,
            alphaMap_0: this.alphaMap_0,
            alphaMap_1: this.alphaMap_1,
            alphaMap_2: this.alphaMap_2,
            alphaMap_3: this.alphaMap_3,
            alphaMap_4: this.alphaMap_4,
            alphaMap_5: this.alphaMap_5,
            alphaMap_6: this.alphaMap_6,
            alphaMap_7: this.alphaMap_7,
            color_0: this.color_0,
            color_1: this.color_1,
            color_2: this.color_2,
            color_3: this.color_3,
            color_4: this.color_4,
            color_5: this.color_5,
            color_6: this.color_6,
            color_7: this.color_7,
            map_0: this.map_0,
            map_1: this.map_1,
            map_2: this.map_2,
            map_3: this.map_3,
            map_4: this.map_4,
            map_5: this.map_5,
            map_6: this.map_6,
            map_7: this.map_7,
            materialIndexDataMap: this.materialIndexDataMap,
            materialIndexDataMapSize: this.materialIndexDataMapSize,
            size_0: this.size_0,
            size_1: this.size_1,
            size_2: this.size_2,
            size_3: this.size_3,
            size_4: this.size_4,
            size_5: this.size_5,
            size_6: this.size_6,
            size_7: this.size_7,
            sizeAttenuation_0: this.sizeAttenuation_0,
            sizeAttenuation_1: this.sizeAttenuation_1,
            sizeAttenuation_2: this.sizeAttenuation_2,
            sizeAttenuation_3: this.sizeAttenuation_3,
            sizeAttenuation_4: this.sizeAttenuation_4,
            sizeAttenuation_5: this.sizeAttenuation_5,
            sizeAttenuation_6: this.sizeAttenuation_6,
            sizeAttenuation_7: this.sizeAttenuation_7,
        }, this.id, this.version);
    }
    copy(source) {
        this.alphaCutoff = source.alphaCutoff;
        this.alphaMode = source.alphaMode;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.emissiveMap = source.emissiveMap;
        this.emissiveness = source.emissiveness;
        this.materialOutput = source.materialOutput;
        this.normalMap = source.normalMap;
        this.normalScale = source.normalScale;
        this.opacity = source.opacity;
        this.shading = source.shading;
        this.side = source.side;
        this.transparent = source.transparent;
        this.alphaMap_0 = source.alphaMap_0;
        this.alphaMap_1 = source.alphaMap_1;
        this.alphaMap_2 = source.alphaMap_2;
        this.alphaMap_3 = source.alphaMap_3;
        this.alphaMap_4 = source.alphaMap_4;
        this.alphaMap_5 = source.alphaMap_5;
        this.alphaMap_6 = source.alphaMap_6;
        this.alphaMap_7 = source.alphaMap_7;
        this.color_0 = source.color_0;
        this.color_1 = source.color_1;
        this.color_2 = source.color_2;
        this.color_3 = source.color_3;
        this.color_4 = source.color_4;
        this.color_5 = source.color_5;
        this.color_6 = source.color_6;
        this.color_7 = source.color_7;
        this.map_0 = source.map_0;
        this.map_1 = source.map_1;
        this.map_2 = source.map_2;
        this.map_3 = source.map_3;
        this.map_4 = source.map_4;
        this.map_5 = source.map_5;
        this.map_6 = source.map_6;
        this.map_7 = source.map_7;
        this.materialIndexDataMap = source.materialIndexDataMap;
        this.materialIndexDataMapSize = source.materialIndexDataMapSize;
        this.size_0 = source.size_0;
        this.size_1 = source.size_1;
        this.size_2 = source.size_2;
        this.size_3 = source.size_3;
        this.size_4 = source.size_4;
        this.size_5 = source.size_5;
        this.size_6 = source.size_6;
        this.size_7 = source.size_7;
        this.sizeAttenuation_0 = source.sizeAttenuation_0;
        this.sizeAttenuation_1 = source.sizeAttenuation_1;
        this.sizeAttenuation_2 = source.sizeAttenuation_2;
        this.sizeAttenuation_3 = source.sizeAttenuation_3;
        this.sizeAttenuation_4 = source.sizeAttenuation_4;
        this.sizeAttenuation_5 = source.sizeAttenuation_5;
        this.sizeAttenuation_6 = source.sizeAttenuation_6;
        this.sizeAttenuation_7 = source.sizeAttenuation_7;
    }
    reset() {
        this.alphaCutoff = 0;
        this.alphaMode = viewer_shared_types_1.MATERIAL_ALPHA.OPAQUE;
        this.aoMap = undefined;
        this.aoMapIntensity = 1.0;
        this.bumpMap = undefined;
        this.bumpScale = 1.0;
        this.depthTest = undefined;
        this.depthWrite = undefined;
        this.emissiveMap = undefined;
        this.emissiveness = "#000000";
        this.materialOutput = false;
        this.normalMap = undefined;
        this.normalScale = 1.0;
        this.opacity = 1.0;
        this.shading = viewer_shared_types_1.MATERIAL_SHADING.SMOOTH;
        this.side = viewer_shared_types_1.MATERIAL_SIDE.DOUBLE;
        this.transparent = undefined;
        this.alphaMap_0 = undefined;
        this.alphaMap_1 = undefined;
        this.alphaMap_2 = undefined;
        this.alphaMap_3 = undefined;
        this.alphaMap_4 = undefined;
        this.alphaMap_5 = undefined;
        this.alphaMap_6 = undefined;
        this.alphaMap_7 = undefined;
        this.color_0 = "#ffffff";
        this.color_1 = "#ffffff";
        this.color_2 = "#ffffff";
        this.color_3 = "#ffffff";
        this.color_4 = "#ffffff";
        this.color_5 = "#ffffff";
        this.color_6 = "#ffffff";
        this.color_7 = "#ffffff";
        this.map_0 = undefined;
        this.map_1 = undefined;
        this.map_2 = undefined;
        this.map_3 = undefined;
        this.map_4 = undefined;
        this.map_5 = undefined;
        this.map_6 = undefined;
        this.map_7 = undefined;
        this.materialIndexDataMap = undefined;
        this.materialIndexDataMapSize = undefined;
        this.size_0 = undefined;
        this.size_1 = undefined;
        this.size_2 = undefined;
        this.size_3 = undefined;
        this.size_4 = undefined;
        this.size_5 = undefined;
        this.size_6 = undefined;
        this.size_7 = undefined;
        this.sizeAttenuation_0 = undefined;
        this.sizeAttenuation_1 = undefined;
        this.sizeAttenuation_2 = undefined;
        this.sizeAttenuation_3 = undefined;
        this.sizeAttenuation_4 = undefined;
        this.sizeAttenuation_5 = undefined;
        this.sizeAttenuation_6 = undefined;
        this.sizeAttenuation_7 = undefined;
    }
}
exports.MaterialMultiPointData = MaterialMultiPointData;
_MaterialMultiPointData_alphaMap_0 = new WeakMap(), _MaterialMultiPointData_alphaMap_1 = new WeakMap(), _MaterialMultiPointData_alphaMap_2 = new WeakMap(), _MaterialMultiPointData_alphaMap_3 = new WeakMap(), _MaterialMultiPointData_alphaMap_4 = new WeakMap(), _MaterialMultiPointData_alphaMap_5 = new WeakMap(), _MaterialMultiPointData_alphaMap_6 = new WeakMap(), _MaterialMultiPointData_alphaMap_7 = new WeakMap(), _MaterialMultiPointData_color_0 = new WeakMap(), _MaterialMultiPointData_color_1 = new WeakMap(), _MaterialMultiPointData_color_2 = new WeakMap(), _MaterialMultiPointData_color_3 = new WeakMap(), _MaterialMultiPointData_color_4 = new WeakMap(), _MaterialMultiPointData_color_5 = new WeakMap(), _MaterialMultiPointData_color_6 = new WeakMap(), _MaterialMultiPointData_color_7 = new WeakMap(), _MaterialMultiPointData_map_0 = new WeakMap(), _MaterialMultiPointData_map_1 = new WeakMap(), _MaterialMultiPointData_map_2 = new WeakMap(), _MaterialMultiPointData_map_3 = new WeakMap(), _MaterialMultiPointData_map_4 = new WeakMap(), _MaterialMultiPointData_map_5 = new WeakMap(), _MaterialMultiPointData_map_6 = new WeakMap(), _MaterialMultiPointData_map_7 = new WeakMap(), _MaterialMultiPointData_materialIndexDataMap = new WeakMap(), _MaterialMultiPointData_materialIndexDataMapSize = new WeakMap(), _MaterialMultiPointData_sizeAttenuation_0 = new WeakMap(), _MaterialMultiPointData_sizeAttenuation_1 = new WeakMap(), _MaterialMultiPointData_sizeAttenuation_2 = new WeakMap(), _MaterialMultiPointData_sizeAttenuation_3 = new WeakMap(), _MaterialMultiPointData_sizeAttenuation_4 = new WeakMap(), _MaterialMultiPointData_sizeAttenuation_5 = new WeakMap(), _MaterialMultiPointData_sizeAttenuation_6 = new WeakMap(), _MaterialMultiPointData_sizeAttenuation_7 = new WeakMap(), _MaterialMultiPointData_size_0 = new WeakMap(), _MaterialMultiPointData_size_1 = new WeakMap(), _MaterialMultiPointData_size_2 = new WeakMap(), _MaterialMultiPointData_size_3 = new WeakMap(), _MaterialMultiPointData_size_4 = new WeakMap(), _MaterialMultiPointData_size_5 = new WeakMap(), _MaterialMultiPointData_size_6 = new WeakMap(), _MaterialMultiPointData_size_7 = new WeakMap();
//# sourceMappingURL=MaterialMultiPointData.js.map